import { render, staticRenderFns } from "./factoryAccount.vue?vue&type=template&id=b655ec5e&scoped=true&"
import script from "./factoryAccount.vue?vue&type=script&lang=js&"
export * from "./factoryAccount.vue?vue&type=script&lang=js&"
import style0 from "./factoryAccount.vue?vue&type=style&index=0&id=b655ec5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b655ec5e",
  null
  
)

export default component.exports